import axios from "axios"
import { onRequest } from "./interceptors"
import { getEnv } from "../../../utils/env"

export const getExportClientUrl = () => {
  return `${getEnv("BASE_REPORTING_API")}/export`
}

const exportClient = axios.create({
  baseURL: getExportClientUrl(),
  headers: {
    "X-Tenant-ID": getEnv("APPLICATION_ID")
  }
})

exportClient.interceptors.request.use(onRequest)

export default exportClient
